import { render } from "./VideoResp.vue?vue&type=template&id=091236ad&scoped=true"
import script from "./VideoResp.vue?vue&type=script&lang=js"
export * from "./VideoResp.vue?vue&type=script&lang=js"

import "./VideoResp.vue?vue&type=style&index=0&id=091236ad&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091236ad"]])

export default __exports__